/**
 * ShopBuyPage - Страница покупки товара (legacy)
 */

import React, { useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import { useSearchParams } from "react-router-dom";
import "simplebar-react/dist/simplebar.min.css";
import { CharacterSelect, Toast } from "../../components/UI";
import { useUserContext } from "../../contexts";
import { ucpService } from "../../api/services/ucpService";
import { getShopImageCandidates } from "../../utils/helpers";

const ShopBuyPage = () => {
    const { fetchDonateBalance } = useUserContext();
    const [searchParams] = useSearchParams();
    const itemId = searchParams.get("item_id");
    const [selectedCharacter, setSelectedCharacter] = useState(null);
    const [itemInfo, setItemInfo] = useState(null);
    const [item, setItem] = useState(null);
    const [toast, setToast] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (!itemId) {
            setToast({
                message: "Товар не найден. Проверьте ссылку.",
                type: "error",
            });
            return;
        }

        const init = async () => {
            try {
                const [info, stats] = await Promise.all([
                    ucpService.getShopItem(itemId),
                    ucpService.getShopItemStats(itemId),
                ]);
                setItemInfo(info);
                setItem(stats);
            } catch (err) {
                console.error("Ошибка загрузки данных предмета:", err.message);
                setToast({
                    message: "Ошибка загрузки данных. Попробуйте позже.",
                    type: "error",
                });
            }
        };

        init();
    }, [itemId]);

    const handlePurchase = async () => {
        setIsSubmitting(true);

        const userId = localStorage.getItem("user-id");
        if (!userId) {
            setToast({
                message: "Ошибка: ID пользователя не найден.",
                type: "error",
            });
            setIsSubmitting(false);
            return;
        }

        const CharId = selectedCharacter?.id || 0;

        try {
            const result = await ucpService.buyItem(CharId, itemId);
            switch (result) {
                case 1:
                    setToast({ message: "Успешная оплата!", type: "success" });
                    await fetchDonateBalance();
                    break;
                case -403:
                    setToast({
                        message: "Ошибка: Проверка пользователя не пройдена",
                        type: "error",
                    });
                    break;
                case -500:
                    setToast({
                        message: "Ошибка: Неверный пароль.",
                        type: "error",
                    });
                    break;
                case -1:
                    setToast({
                        message: "Ошибка: Недостаточно средств.",
                        type: "error",
                    });
                    break;
                case -2:
                    setToast({
                        message: "У вас уже есть премиум-аккаунт.",
                        type: "error",
                    });
                    break;
                case -3:
                    setToast({
                        message: "Превышен лимит транспорта.",
                        type: "error",
                    });
                    break;
                default:
                    setToast({
                        message: "Неизвестная ошибка. Попробуйте позже.",
                        type: "error",
                    });
                    break;
            }
        } catch (error) {
            console.error("Ошибка при покупке:", error);
            setToast({
                message: "Ошибка при покупке. Проверьте подключение.",
                type: "error",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <main className="shop-main">
            <div className="shop-buy-page">
                <div className="shop-buy-page__sidebar">
                    <div className="shop-buy-character">
                        <img
                            src={getShopImageCandidates(itemInfo?.imgUrl)[0]}
                            alt={itemInfo?.name || ""}
                            onError={(event) => {
                                const candidates = getShopImageCandidates(
                                    itemInfo?.imgUrl,
                                );
                                const currentIndex = Number(
                                    event.currentTarget.dataset
                                        .candidateIndex || 0,
                                );
                                const nextIndex = currentIndex + 1;
                                if (nextIndex >= candidates.length) {
                                    return;
                                }
                                event.currentTarget.dataset.candidateIndex =
                                    String(nextIndex);
                                event.currentTarget.src = candidates[nextIndex];
                            }}
                        />
                        <span className="shop-buy-character__name">
                            {itemInfo
                                ? String(itemInfo.name).toUpperCase()
                                : "ЗАГРУЗКА..."}
                        </span>
                    </div>
                </div>
                <div className="simplebar-wrapper shop-buy-page__aside">
                    <SimpleBar className="shop-buy-scroll simplebar-track-shop-buy">
                        {itemInfo && itemInfo.type !== 1 && (
                            <>
                                <h2 className="shop-buy-section-title">
                                    ВЫБОР ПЕРСОНАЖА
                                </h2>
                                <div className="shop-buy-character-picker">
                                    <CharacterSelect
                                        onSelect={setSelectedCharacter}
                                    />
                                </div>
                            </>
                        )}

                        <h2 className="shop-buy-section-title">
                            ХАРАКТЕРИСТИКИ
                        </h2>

                        <div className="shop-buy-stats">
                            <ul>
                                {item ? (
                                    Object.entries(item).map(([key, value]) => (
                                        <li key={key}>{value}</li>
                                    ))
                                ) : (
                                    <li>Загрузка характеристик...</li>
                                )}
                            </ul>
                        </div>

                        <button
                            type="button"
                            className={`shop-buy-purchase-btn shop-primary-button shop-primary-button--purchase has-inline-loader ${
                                isSubmitting ? "is-loading" : ""
                            }`}
                            onClick={handlePurchase}
                            disabled={isSubmitting || !itemId}
                            aria-busy={isSubmitting}
                        >
                            <span className="inline-loader__label">КУПИТЬ</span>
                            {isSubmitting ? (
                                <span
                                    className="btn__loader inline-loader"
                                    aria-label="Загрузка"
                                >
                                    <span className="btn__loader-dot"></span>
                                    <span className="btn__loader-dot"></span>
                                    <span className="btn__loader-dot"></span>
                                </span>
                            ) : null}
                        </button>
                    </SimpleBar>
                </div>
            </div>

            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    duration={4500}
                    onClose={() => setToast(null)}
                />
            )}
        </main>
    );
};

export default ShopBuyPage;
